export const TESTS = {
    SLP_PROPERTY_TYPE_PRICES: 'HA_PTA_SLP_FromPricesPropertyTypesCarouselV2',
    GDPR: 'ha_gdpr_banner',
    REDESIGN_QA_SEO_TEXT: 'HA_PTA_LANDING_RedesignQASEOText',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    LOW_LEVEL_GEO_TEMPLATE: 'HA_PTA_LANDING_LowLevelGeoSLPTemplate',
    HIGH_LEVEL_GEO_TEMPLATE: 'HA_PTA_LANDING_HighLevelGeoSLPTemplate',
    PROPERTY_TYPE_NAME_LISTING_CARDS: 'HA_PTA_LANDING_PropertyTypeNameListingCards',
    STREAM_LANDING: 'HA_PTA_SLP_StreamLanding',
    ORIGIN_CORRIDOR_DESTINATIONS: 'HA_PTA_LANDING_SLPOriginCorridorDestinations',
    DISCOVERY_PROPERTY_FEED: 'HA_PTA_LANDING_DiscoveryfeedSLPs',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    DISCOVERY_DESTINATIONS: 'HA_PTA_LANDING_DestinationDiscoveryfeedSLPs',
    CAROUSEL_PAGE_SIZE: 'HA_PTA_LANDING_CarouselPageSize',
    PROPERTY_TITLE_IN_LISTING_CARD: 'HA_PTA_LANDING_PropertyTitleInListingCard',
    DESTINATION_RECOMMENDATIONS: 'HA_PTA_LANDING_SimilarDestinationsonSLPs',
    SEO_LINK_PILE_ON_ROOT_PAGE: 'HA_PTA_LANDING_SLPRootOnPlatformLinkpile',
    MLP_SEO_LINKPILE: 'HA_PTA_LANDING_MLPOnPlatformLinkpile',
    SEO_LINK_PILE_ON_DESTINATION_PAGE: 'HA_PTA_LANDING_SLPOnPlatformSEOLinkpileExpanded',
    AFFINITIES_CITY_CAROUSEL: 'HA_PTA_LANDING_AffinitiesCityCarouselSLP',
    JUMBOTRON_HEADING_TEXT: 'HA_PTA_LANDING_SLP_KeywordInH1',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    BREADCRUMB_IN_HEADER: 'HA_PTA_LANDING_SLPReduceAndRepositionBreadcrumb',
    HA_TYPEAHEAD_HIGHLIGHTS: 'ha_typeahead_highlights',
    HA_TYPEAHEAD_SCROLL_TO_TOP: 'HA_TYPEAHEAD_SCROLL_TO_TOP',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display',
    MAP_PROPERTIES_REDESIGN: 'HA_PTA_LANDING_MapPropertiesRedesignMobile',
    SEARCH_FORM_SLP: 'HA_PTA_SEARCH_FORM_SLP',
    SEARCH_FORM_MLP: 'HA_PTA_Search_Form_MLP',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    DATELESS_RANKING: 'HA_PTA_LANDING_DatelessRanking',
    LANDING_NEW_HEADINGS: 'HA_PTA_LANDING_NewHeadings',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY'
};

export const EVALUATE = [
    TESTS.SLP_PROPERTY_TYPE_PRICES,
    TESTS.GDPR,
    TESTS.REDESIGN_QA_SEO_TEXT,
    TESTS.POLYFILL_SERVICE,
    TESTS.LOW_LEVEL_GEO_TEMPLATE,
    TESTS.HIGH_LEVEL_GEO_TEMPLATE,
    TESTS.PROPERTY_TYPE_NAME_LISTING_CARDS,
    TESTS.STREAM_LANDING,
    TESTS.ORIGIN_CORRIDOR_DESTINATIONS,
    TESTS.DISCOVERY_PROPERTY_FEED,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.DISCOVERY_DESTINATIONS,
    TESTS.CAROUSEL_PAGE_SIZE,
    TESTS.PROPERTY_TITLE_IN_LISTING_CARD,
    TESTS.DESTINATION_RECOMMENDATIONS,
    TESTS.SEO_LINK_PILE_ON_ROOT_PAGE,
    TESTS.MLP_SEO_LINKPILE,
    TESTS.SEO_LINK_PILE_ON_DESTINATION_PAGE,
    TESTS.AFFINITIES_CITY_CAROUSEL,
    TESTS.JUMBOTRON_HEADING_TEXT,
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.HA_TYPEAHEAD_HIGHLIGHTS,
    TESTS.HA_TYPEAHEAD_SCROLL_TO_TOP,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.MAP_PROPERTIES_REDESIGN,
    TESTS.SEARCH_FORM_SLP,
    TESTS.SEARCH_FORM_MLP,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.DATELESS_RANKING,
    TESTS.LANDING_NEW_HEADINGS,
    TESTS.HA_PTA_HEADER_LOGIN_COPY
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    return hasTest(abacus, test) ?
        abacus[test].value :
        null;
};
